<script setup lang="ts">
defineProps<{
  label: stringI18n
  sup?: string | number | None | boolean
  sub?: string | None
  right?: boolean
  fw?: '_fw-xl' | '_fw-l'
}>()
</script>

<template>
  <span class="_col _gap02 _pr02 _flex" :class="right && '_txt_end'">
    <span class="_ls-xs" :class="fw || '_fw-xl'">
      {{ label }}
      <sup v-if="helpers.isDef(sup) && sup !== false" class="_inline" :class="$style.sup">{{ typeof sup !== 'boolean' ? helpers.zeroPad(sup) : undefined }}</sup>
    </span>
    <span v-if="helpers.isDef(sub)" :class="$style.sub">{{ sub }}</span>
  </span>
</template>

<style module>
.sub {
  composes: global(sub);
  composes: global(_fs07);
  composes: global(_ls-xs);
  composes: global(_lh1);
  composes: global(_pb02);
  composes: global(_ff3);
  composes: global(_fw-xl);
  composes: global(_ellipsis);
}
.sub:global(.sub) {
  color: var(--black-45);
  word-spacing: 2px;
  width: 0;
  min-width: 100%;
}
.sup {
  min-width: 12px;
}
</style>
